import { createFileRoute } from "@tanstack/react-router"
import { uomLoader } from "shared/loaders"

import { FinalizeCheckInScreen } from "@/screens/WarehouseReceiving/subfeatures/SoftReceived/components/FinalizeCheckIn/FinalizeCheckInScreen"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in")(
  {
    loader: uomLoader,
    component: FinalizeCheckInScreen,
  }
)
